import { render, staticRenderFns } from "./employ_image.vue?vue&type=template&id=84467528&scoped=true&"
import script from "./employ_image.vue?vue&type=script&lang=js&"
export * from "./employ_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84467528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84467528')) {
      api.createRecord('84467528', component.options)
    } else {
      api.reload('84467528', component.options)
    }
    module.hot.accept("./employ_image.vue?vue&type=template&id=84467528&scoped=true&", function () {
      api.rerender('84467528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/employees/modal/tabs/employ_image.vue"
export default component.exports